export default "__VITE_ASSET__vST9zJLB__"